import React, { useId } from 'react';
import { useFormContext } from 'react-hook-form';

import { cn } from '@epoch-ui/lib/utils';
import { ButtonGroup, ButtonGroupItem } from '@epoch-ui/components/ButtonGroup';

import {
  FormField,
  FormControl,
  FormDescription,
  FormLabel,
  FormItem,
  FormMessage
} from '../../form';

export interface ButtonGroupFieldProps extends React.ComponentPropsWithRef<typeof ButtonGroup> {
  name: string;
  label?: string | React.ReactNode | React.ReactNode[];
  description?: string | React.ReactNode | React.ReactNode[];
}

export const ButtonGroupField: React.FC<ButtonGroupFieldProps> = ({
  name,
  label,
  description,
  className,
  onValueChange,
  ...props
}) => {
  const formCtx = useFormContext();
  const id = useId();
  return (
    <FormField
      control={formCtx.control}
      name={name || id}
      render={({ field, fieldState }): React.ReactElement => (
        <FormItem>
          {label && (
            <FormLabel className={cn('tw-mb-0', props.disabled && 'tw-opacity-40')}>
              {label}
            </FormLabel>
          )}
          {description && (
            <FormDescription className={cn('tw-m-0', props.disabled && 'tw-opacity-40')}>
              {description}
            </FormDescription>
          )}
          <FormControl className="tw-mt-2">
            <ButtonGroup
              ref={field.ref}
              name={field.name}
              value={field.value}
              onValueChange={(value) => {
                field.onChange(value);
                onValueChange?.(value);
              }}
              className={className}
              {...props}
              error={!!fieldState.error}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export const ButtonGroupFieldItem = ButtonGroupItem;
